export { View as SuccessCard } from './view'
